<template>
  <!--<BaseBusiness :formParams='formParamsBase' :opCode="opCode" ref="base"></BaseBusiness>-->
  <ParseForm :formParams='formParams' ref='base' formId="formParams.formId" :opCode="opCode" :funcClick="bindClickEvent" :funcOnChange="onChangeEvent"></ParseForm>
</template>

<script>
// import BaseBusiness from './group/U_BaseBusinessNew';
// import SubscriberArr from '../../../plugins/subscriberArr';
import SubscriberTool from '../util/parseFormNew/tools/subscriberTool';
import ParseForm from '../util/parseFormNew/ParseForm';

export default {
  name: 'MemberInfoCommon',
  components: {
    // BaseBusiness
    ParseForm
  },
  props: [
    'opCode',
    'impugrpclassIndex',
    'impugrppriorityIndex',
    'grppropertyIndex',
    'neid',
    'msgid'
  ],
  data() {
    return {
      memberInfo: new Map(),
      formParams: {
        json: '',
        formId: `${this.opCode}baseBussiness`,
        subObject: '',
        modelName: 'noGroup',
      },
      radioSelectMap: new Map(),
      impugrpclassMap: new Map(),
      impugrpclassTempMap: new Map(),
      funcClickMap: new Map(),
      funcChangeMap: new Map(),
    };
  },
  methods: {
    initHandler() {
      const $this = this;
      const param = {
        msgid: this.msgid,
        neid: this.neid
      };
      // 查询隶属关系配置内容
      $this.$axios.post('/lte/ems/subscriber/imsunms/getParamJson', param).then((response) => {
        const res = response.data.resultVal;
        let resInfo = [];
        // 获取attrlist
        for (let i = 0; i < res.length; i++) {
          if (typeof (res[i].attrList) !== 'undefined') {
            resInfo = res[i].attrList;
            break;
          }
        }
        $this.setMemberInfo(resInfo);
      });
    },
    mainHandler(data = [], property = {}, qryDataFunFlag = false) {
      const $this = this;
      // let subscriberArr = null;
      let arrBase = null;
      const param = {
        msgid: this.msgid,
        neid: this.neid
      };
      // 查询隶属关系配置内容
      this.$axios.post('/lte/ems/subscriber/imsunms/getParamJson', param).then((response) => {
        const res = response.data.resultVal;
        let resInfo = [];
        // 获取attrlist
        for (let i = 0; i < res.length; i++) {
          if (typeof (res[i].attrList) !== 'undefined') {
            resInfo = res[i].attrList;
            break;
          }
        }
        const sub = new SubscriberTool();
        console.log(data);
        const resultMap = sub.$devideByGroupBy(resInfo, data.length === 1 ? data[0] : data);
        arrBase = resultMap.get($this.formParams.modelName);
        $this.formParams = arrBase;
        // subscriberArr = new SubscriberArr(resInfo, 1);
        this.setMemberInfo(resInfo);
        // let bussinessMap = new Map();
        // if (property.opCode === 'mod') {
        //   subscriberArr.setDatas(data[0]);
        //   bussinessMap = subscriberArr.getTempletByGroup(1);
        // } else if (property.opCode === 'add') {
        //   bussinessMap = subscriberArr.getTempletByGroup(0);
        // }
        // arrBase = bussinessMap.get($this.formParamsBase.modelName);
        // $this.formParamsBase.json = arrBase;
        // $this.formParamsBase.subObject = subscriberArr;
        // $this.reMount();
        // console.log('我是子组件，父组件是，如果有getGridData', $this.$refs.base.$parent.$parent);
        if (qryDataFunFlag) {
          $this.$refs.base.$parent.$parent.getGridData($this.$refs.base.$parent.$parent.node);
        }
        // setTimeout(() => {
        //   $this.bindClickAfterPageCreated();
        // }, 200);
      });
    },
    // reMount() {
    //   this.$refs.base.reMount();
    // },
    getMemberInfo() {
      return this.memberInfo;
    },
    getDatas() {
      return this.$refs.base.getDatas();
    },
    bindClickAfterPageCreated() {
      console.log(document.getElementById('addMemeberbaseBussiness').querySelectorAll('input[type="checkbox"]'));
      const inputCheckbox = document.getElementById('addMemeberbaseBussiness').querySelectorAll('input');
      if (inputCheckbox && inputCheckbox.length > 0) {
        for (let i = 0; i < inputCheckbox.length; i++) {
          inputCheckbox[i].onclick = this.modTdText;
        }
      }
    },
    modTdTextForCheckboxClickNew(name) {
      const $this = this;
      const configInfo = this.memberInfo.get(name);
      const selectedrowindex = $this.$parent.$refs.grid.getSelectedRowIndexes();
      console.log('selectedrowindex=', selectedrowindex);
      if (selectedrowindex) {
        // checkbox事件改变列数据
        selectedrowindex.forEach(index => {
          const checkValue = $this.$refs.base.getAttrByName(name, 'value');
          $this.$parent.$refs.grid.dataSource[index][`${name}`] = checkValue;
          const trLists = $this.$parent.$refs.grid.$el.getElementsByTagName('tbody')[1].querySelectorAll('tr');
          trLists[index].querySelectorAll('td')[configInfo.index].textContent = this.impugrpclassShow(checkValue);
        });
      }
    },
    modTdTextForRadioClickNew(name) {
      const configInfo = this.memberInfo.get(name);
      const selectDatas = this.$parent.$refs.grid.getSelectedRecords();
      const selectedrowindex = this.$parent.$refs.grid.getSelectedRowIndexes();
      if (selectDatas) {
        const trLists = this.$parent.$refs.grid.$el.getElementsByTagName('tbody')[1].querySelectorAll('tr');
        console.log('indexs length and selectDatas length', trLists.length, selectDatas.length, configInfo.valueMap);
        // radio事件改变列数据
        // 获取radio的值
        const radioVal = this.$refs.base.getAttrByName(name, 'value').toString();
        console.log('radioVal', radioVal);
        selectedrowindex.forEach(index => {
          trLists[index].querySelectorAll('td')[configInfo.index].textContent = configInfo.valueMap.get(radioVal.toString()) ? configInfo.valueMap.get(radioVal.toString()) : 0;
          // selectDatas[index][name] = radioVal;
        });
        selectDatas.forEach((item) => {
          item[name] = radioVal;
        });
      }
    },
    modTdText(args) {
      // 改变列数据----选择行
      const selectedrowindex = this.$parent.$refs.grid.getSelectedRowIndexes();
      if (selectedrowindex) {
        const inputDom = args.path[0];
        const configInfo = this.memberInfo.get(inputDom.name);
        const trLists = this.$parent.$refs.grid.$el.getElementsByTagName('tbody')[1].querySelectorAll('tr');
        if (inputDom.type === 'checkbox') {
          this.modTdTextForCheckboxClick(inputDom, configInfo, selectedrowindex, trLists);
        } else if (inputDom.type === 'radio') {
          this.modTdTextForRadioClick(inputDom, configInfo, selectedrowindex, trLists);
        }
      }
    },
    modTdTextForCheckboxClick(dom, configInfo, selectedrowindex, trLists) {
      // checkbox事件改变列数据
      selectedrowindex.forEach(index => {
        // const textValue = trLists[index].querySelectorAll('td')[configInfo.index].textContent;
        // const checkboxValue = trLists[index].querySelectorAll('td')[9].textContent;
        // const checkboxValueList = checkboxValue.split(',');
        const checkboxValueList = this.$parent.$refs.grid.dataSource[index][`${dom.name}_hidden`];
        console.log('dom.value=', dom.value, checkboxValueList, checkboxValueList[parseInt(dom.value, 0)]);
        console.log('-----------', parseInt(dom.value, 0));
        if (dom.checked) {
          // const value = configInfo.valueMap.get(dom.value);
          // trLists[index].querySelectorAll('td')[configInfo.index].textContent = textValue === '' ? value : `${textValue}/${value}`;
          checkboxValueList[parseInt(dom.value, 0)] = 1;
        } else {
          // const reg = new RegExp(`${configInfo.valueMap.get(dom.value)}/`);
          // trLists[index].querySelectorAll('td')[configInfo.index].textContent = textValue.replace(reg, '');
          checkboxValueList[parseInt(dom.value, 0)] = 0;
        }
        // trLists[index].querySelectorAll('td')[9].textContent = checkboxValueList.toString();
        // console.log(trLists[index].querySelectorAll('td')[9].textContent);
        console.log(this.$parent.$refs.grid.dataSource[index][`${dom.name}_hidden`]);
        this.$parent.$refs.grid.dataSource[index][`${dom.name}_hidden`] = checkboxValueList;
        // checkboxValueList转换成10进制
        let count = checkboxValueList.length - 1;
        let result = 0;
        while (count >= 0) {
          if (checkboxValueList[count] === 1 || checkboxValueList[count] === '1') {
            result += Math.pow(2, count);
          }
          count--;
        }
        trLists[index].querySelectorAll('td')[configInfo.index].textContent = this.impugrpclassShow(result);
        console.log(this.$parent.$refs.grid.dataSource[index][`${dom.name}_hidden`]);
      });
    },
    modTdTextForRadioClick(dom, configInfo, selectedrowindex, trLists) {
      const selectDatas = this.$parent.$refs.grid.getSelectedRecords();
      console.log('indexs length and selectDatas length', trLists.length, selectDatas.length);
      // radio事件改变列数据
      const radioSelect = this.radioSelectMap.get(dom.name);
      if (radioSelect) {
        if (radioSelect.id !== dom.id) {
          selectedrowindex.forEach(index => {
            trLists[index].querySelectorAll('td')[configInfo.index].textContent = configInfo.valueMap.get(dom.value) ? configInfo.valueMap.get(dom.value) : 0;
            selectDatas[index][dom.name] = dom.value;
          });
          this.radioSelectMap.set(dom.name, dom.id);
        }
      } else {
        this.radioSelectMap.set(dom.name, dom.id);
        selectedrowindex.forEach(index => {
          trLists[index].querySelectorAll('td')[configInfo.index].textContent = configInfo.valueMap.get(dom.value) ? configInfo.valueMap.get(dom.value) : 0;
          selectDatas[index][dom.name] = dom.value;
        });
      }
    },
    setMemberInfo(resInfo) {
      // 针对checkbox和radio
      resInfo.forEach(item => {
        if (item.type === 'checkbox' || item.type === 'radio') {
          const temp = {};
          temp.name = item.name;
          temp.type = item.type;
          const valueMap = new Map();
          item.options.forEach(option => {
            valueMap.set(option.value.toString(), option.showName);
          });
          temp.valueMap = valueMap;
          this.memberInfo.set(item.name, temp);
        }
      });
      // 对应列表中td的index值
      this.setTdIndex(this.memberInfo.get('impugrpclass'), this.impugrpclassIndex);
      this.setTdIndex(this.memberInfo.get('impugrppriority'), this.impugrppriorityIndex);
      this.setTdIndex(this.memberInfo.get('grpproperty'), this.grppropertyIndex);
    },
    setTdIndex(obj, index) {
      if (obj) {
        obj.index = index;
      }
    },
    impugrpIre(value, count) {
      const val = Math.pow(2, count);
      if (val === value) {
        this.impugrpclassTempMap.set(count, true);
      } else if (val > value) {
        this.impugrpclassTempMap.set(count, false);
        this.impugrpIre(value, --count);
      } else if (val < value) {
        this.impugrpclassTempMap.set(count, true);
        this.impugrpIre(value - val, --count);
      }
    },
    // 设置用户组内权限
    impugrpclassShow(value, mem = new Map()) {
      let impugrpclassList = '';
      if (mem.size > 0) {
        impugrpclassList = mem.get('impugrpclass').valueMap;
      } else {
        impugrpclassList = this.memberInfo.get('impugrpclass').valueMap;
      }
      if (this.impugrpclassMap.size > 0 && this.impugrpclassMap.get(value)) {
        return this.impugrpclassMap.get(value);
      }
      let resultShow = '';
      if (value === 0) {
        return resultShow;
      }
      this.impugrpclassTempMap = new Map();
      const len = impugrpclassList.size - 1;
      this.impugrpIre(value, len);
      for (let i = 0; i <= len; i++) {
        if (this.impugrpclassTempMap.get(i)) {
          resultShow += `${impugrpclassList.get(i.toString())}/`;
        }
      }
      if (resultShow.substring(resultShow.length - 1, resultShow.length) === '/') {
        resultShow = resultShow.substring(0, resultShow.length - 1);
      }
      this.impugrpclassMap.set(value, resultShow);
      return resultShow;
      switch (value) {
        case 0:
          resultShow = '';
          break;
        case 1:
          resultShow = `${impugrpclassList.get('0')}`;
          break;
        case 2:
          resultShow = `${impugrpclassList.get('1')}`;
          break;
        case 3:
          resultShow = `${impugrpclassList.get('0')}/${impugrpclassList.get('1')}`;
          break;
        case 4:
          resultShow = `${impugrpclassList.get('2')}`;
          break;
        case 5:
          resultShow = `${impugrpclassList.get('0')}/${impugrpclassList.get('2')}`;
          break;
        case 6:
          resultShow = `${impugrpclassList.get('1')}/${impugrpclassList.get('2')}`;
          break;
        case 7:
          resultShow = `${impugrpclassList.get('0')}/${impugrpclassList.get('1')}/${impugrpclassList.get('2')}`;
          break;
        default:
          resultShow = `${impugrpclassList.get('0')}/${impugrpclassList.get('1')}/${impugrpclassList.get('2')}`;
          break;
      }
      this.impugrpclassMap.set(value, resultShow);
      return resultShow;
    }
  },
  computed: {
    bindClickEvent() {
      this.funcClickMap = new Map();
      const clickMap = new Map();
      clickMap.set('all', () => { console.log('-----------------------'); this.modTdTextForCheckboxClickNew('impugrpclass'); } );
      this.funcClickMap.set('impugrpclass', clickMap);
      return this.funcClickMap;
    },
    onChangeEvent() {
      this.funcChangeMap = new Map();
      this.funcChangeMap.set('impugrppriority', () => { this.modTdTextForRadioClickNew('impugrppriority'); });
      this.funcChangeMap.set('grpproperty', () => { this.modTdTextForRadioClickNew('grpproperty'); });
      return this.funcChangeMap;
    }
  },
};
</script>
<style scoped>

</style>
